.i1{border-radius:0.375rem;}